import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TABS_DATA } from '../../constants';

@Component({
  selector: 'app-search-tabs',
  templateUrl: './search-tabs.component.html',
  styleUrls: ['./search-tabs.component.scss'],
})
export class SearchTabsComponent {
  @Output() selectTab = new EventEmitter<number>();
  @Input() currentTab: number = 0;

  tabs = TABS_DATA;

  clickTab(event: MouseEvent, path: string, index: number) {
    event.preventDefault();
    this.currentTab = index;
    this.selectTab.emit(index);
  }

  isActiveRoute(index: number): boolean {
    return this.currentTab === index;
  }
}
